module.exports = __webpack_public_path__ + "static/media/020.d8e6b91a.jpg";